<template>
  <div class="flex h-96 w-full items-center justify-center">
    <div class="text-center">
      <p class="mb-1 block text-lg font-medium text-primary">
        No Metrics Selected
      </p>
      <p class="mx-auto mb-4 w-3/5 text-tertiary">
        To configure the Metrics for your organization, click on Select ESG
        Metrics
      </p>
      <button
        type="button"
        class="font-inter transform rounded bg-main-primary px-4 py-1.5 text-center text-sm text-white shadow-sm hover:-translate-y-0.5 hover:bg-main-secondary active:bg-main-primary"
        @click="$emit('select')"
      >
        Select ESG Metrics
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyEsgTopicMetrics',

  emits: ['select'],
}
</script>
